export default __webpack_public_path__ + "static/media/rnm1.158fe89a.jpeg";